import { getToken, logout } from './session'
import LoginError from '../error/LoginError'
import NetworkError from '../error/NetworkError'

enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

export const json = {
  get: async function (url: string, params?: any) {
    return get(url, params)
  },
  post: async function (url: string, json: any) {
    return _json(url, json, HttpMethod.POST)
  },
  put: async function (url: string, json: any) {
    return _json(url, json, HttpMethod.PUT)
  },
  delete: async function (url: string) {
    return _json(url, {}, HttpMethod.DELETE)
  },
  deleteAll: async function (url: string, json: Array<any>) {
    return _json(url, json, HttpMethod.DELETE)
  },
}

async function get (url: string, params?: any) {
  try {
    if (params) {
      url = `${url}?${_encodeParam(params)}`
    }
    const response = await fetch(url, {
      credentials: 'include',
      headers: new Headers({
        'Content-Type': 'application/json',
        'x-access-token': getToken(),
      })
    })
    if (response.status === 401) {
      logout()
      // noinspection ExceptionCaughtLocallyJS
      throw new LoginError()
    }
    return await response.json()
  } catch (e) {
    if (e instanceof LoginError) {
      throw e
    }
    throw new NetworkError()
  }
}

async function _json (url: string, json: any, method: HttpMethod) {
  try {
    const response = await fetch(url, {
      credentials: 'include',
      method: method,
      headers: new Headers({
        'Content-Type': 'application/json',
        'x-access-token': getToken(),
      }),
      body: JSON.stringify(json),
    })
    if (response.status === 401) {
      logout()
      // noinspection ExceptionCaughtLocallyJS
      throw new LoginError()
    }
    return await response.json()
  } catch (e) {
    if (e instanceof LoginError) {
      throw e
    }
    throw new NetworkError()
  }
}

function _encodeParam (param: any): string {
  return Object.keys(param)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(param[key] ? param[key] : '')}`)
    .join('&')
}

export function getSessionHeader() {
  return {
    'x-access-token': getToken()
  }
}